.content {
  font-family: var(--nexus-font-sans);
  font-size: var(--nexus-text-base);
  line-height: 1.7;
  color: var(--nexus-text);
}

.content h1 {
  font-size: 1.75em;
  font-weight: 700;
  margin: 1em 0 0.4em;
  line-height: 1.3;
}

.content h2 {
  font-size: 1.4em;
  font-weight: 700;
  margin: 1em 0 0.4em;
  line-height: 1.3;
}

.content h3 {
  font-size: 1.15em;
  font-weight: 600;
  margin: 0.75em 0 0.3em;
  line-height: 1.4;
}

.content p {
  margin: 0.6em 0;
}

.content ul,
.content ol {
  margin: 0.6em 0;
  padding-left: 1.5em;
}

.content li {
  margin: 0.3em 0;
}

.content blockquote {
  margin: 1em 0;
  padding: var(--nexus-space-sm) var(--nexus-space-lg);
  border-left: 3px solid var(--nexus-purple);
  background: rgba(178, 75, 243, 0.06);
  border-radius: 0 var(--nexus-radius-sm) var(--nexus-radius-sm) 0;
  color: var(--nexus-text-secondary);
  font-style: italic;
}

.content a {
  color: var(--nexus-purple);
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color var(--nexus-transition-fast);
}

.content a:hover {
  color: var(--nexus-pink);
}

.content img {
  max-width: 100%;
  height: auto;
  border-radius: var(--nexus-radius-media);
  margin: 1em 0;
}

.content strong {
  font-weight: 700;
}

.content em {
  font-style: italic;
}

.content s {
  text-decoration: line-through;
}

.content hr {
  border: none;
  border-top: 1px solid var(--nexus-border);
  margin: 1.5em 0;
}

.content code {
  padding: 2px 6px;
  background: var(--nexus-surface-hover);
  border-radius: var(--nexus-radius-sm);
  font-family: var(--nexus-font-mono);
  font-size: 0.9em;
}

.content pre {
  margin: 1em 0;
  padding: var(--nexus-space-md);
  background: var(--nexus-surface-hover);
  border-radius: var(--nexus-radius-surface);
  overflow-x: auto;
}

.content pre code {
  padding: 0;
  background: none;
}

/* A run of markdown between embeds; it lays out as if the wrapper weren't there. */
.chunk {
  display: contents;
}
